const getQuantity = (items = []) => {
  let qty = 0
  items.forEach(item => {
    const quantity = item?.quantity || item?.qty
    qty += parseInt(quantity, 10)
  })
  return qty
};

export default getQuantity
